// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import http from './http'
import store from './store/index'
import Vuex from 'vuex'
import moment from 'moment-timezone'
import 'babel-polyfill'
import 'lib-flexible'
import uuid from './utils/uuid.js'
import 'echarts/lib/component/tooltip'
Vue.prototype.uuid = uuid
Vue.use(moment)
Vue.use(Vuex)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.filter('dataFormat', function (value, fmt) {
    if (fmt == null || fmt == undefined || fmt == 'undefined') {
        fmt = 'yyyy-MM-dd hh:mm:ss';
    }
    let getDate = new Date(value);
    let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return fmt;
});
if (!localStorage.getItem('deviceId')) {
    let timestamp = new Date().getTime();
    //获取第16位到32位
    let deviceId = '' + uuid.uuid(16, 32) + timestamp;
    localStorage.setItem('deviceId', deviceId);
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    http,
    components: { App },
    template: '<App/>'
});

console.info("VERSION " + VERSION);


// WEBPACK FOOTER //
// ./src/main.js